import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http : HttpClient) { }

  deleteUser(uid: string, email : string) {
    return from(
      this.http.post(
        'https://us-central1-flyhigh-tutors.cloudfunctions.net/deleteUser',
        {uid : uid, email : email}
      )
    );
  }


  registerBusinessOwner(data : any) {
    return from(
      this.http.post(
        'https://us-central1-mbc-387af.cloudfunctions.net/registerUser',
       data
      )
    );
  }

  registerParents(data : any) {
    return from(
      this.http.post(
        'https://us-central1-flyhigh-tutors.cloudfunctions.net/registerParent',
       data
      )
    );
  }
  
}
